// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"6822":"e307bb9c","8428":"e307bb9c"}[chunkId] + ".chunk.css");